export const environment = {
  firebase: {
    projectId: 'next2u-prod',
    appId: '1:353344077923:web:af6740eaf2f61691d23856',
    storageBucket: 'next2u-prod.appspot.com',
    locationId: 'europe-west',
    apiKey: 'AIzaSyAfUt8diLKqn-ui1tHnmCUb6mkWU_8na5E',
    authDomain: 'next2u-prod.web.app',
    messagingSenderId: '353344077923',
    measurementId: 'G-CZGK1K55NF',
  },
  production: true,
  baseURL: 'https://europe-west1-next2u-prod.cloudfunctions.net/admin_europe',
  spaceClaimBaseURL: 'https://europe-west1-next2u-prod.cloudfunctions.net/spaceclaim_europe',  
  shareProfile: {
    getProfileLink: (profileId: string) =>
      encodeURIComponent(
        `share_profile=yUSx3w_4Ni&profile=${profileId}`
      ),
    getLink: (profileId: string) =>
      `https://nx2u.app/l?deep_link_value=${environment.shareProfile.getProfileLink(
        profileId
      )}`,
  },
  /*
   * The link that joins a space, as a QR code on the admin event page.
   *
   * `eventid=<id>` is what the app registers the scanner with
   * (DynamicLinkExternalNotification -> handleEventLink -> registerMeToEvent);
   * `claim_space=<id>`, which the claim wizard shows, hands over ownership
   * instead. Two different codes for the same space, so they are never built
   * by hand at a call site.
   */
  joinEvent: {
    getLink: (eventId: string) =>
      `https://nx2u.app/l?deep_link_value=${encodeURIComponent(
        `eventid=${eventId}`
      )}`,
  },
};
